// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_B8E","cls2":"ProfilePdfPackCard-cls2_TqS ProfilePdfPackCard-cls1_B8E"};